import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MessageServerService } from '../services/hub-services/message-server/message-server.service';
import { VideoChatService } from '../services/video-chat/video-chat.service';
import { PrintWebSocketService } from '../services/print-web-socket.service';
import { MobileScannService } from '../services/hub-services/mobile-scann/mobile-scann.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {

  title = 'app';
  constructor(
    private printWebSocketService: PrintWebSocketService, 
    private messageServerService: MessageServerService) { 
    this.messageServerService.createHubProxyAndStarConnection(); 
    this.printWebSocketService.initConnection();
  }
}
